
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Usuario, CambiarPassword } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  url = environment.url + '/usuarios';

  constructor(private http: HttpClient) {}

  count() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/count?cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }


  getAllByCliente(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }&cliente=${ localStorage.getItem('idCliente') }`, { headers }).pipe( map( data => data));
  }

  getAll(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }&cliente=${ null }`, { headers }).pipe( map( data => data));
  }

  getByUsername(username: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/id?usuario=${ username }`, { headers }).pipe( map( data => data));
  }

  getById() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/id?usuario=${ localStorage.getItem('idUsuario') }`, { headers }).pipe( map( data => data));
  }

  add(usuario: Usuario) {
    let body = JSON.stringify(usuario);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    let rol = 'ADMINISTRADOR';
    return this.http.post(`${ this.url }/add?cliente=${ localStorage.getItem('idCliente') }&mdc=${ localStorage.getItem('idMdc') }&rol=${ rol }&usuario=${ localStorage.getItem('idUsuario')}`, body, { headers }).pipe( map( data => data));
  }

  update(usuario: Usuario) {
    let body = JSON.stringify(usuario);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.put(`${ this.url }/update?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  updatePassword(contrasenia: CambiarPassword) {
    let body = JSON.stringify(contrasenia);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.put(`${ this.url }/update-passwords?&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }
  
  delete(usuario: Usuario) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.delete(`${ this.url }/delete/?usuario=${ usuario.username }&cliente=${ localStorage.getItem('idCliente') }&idUsuario=${ localStorage.getItem('idUsuario') }`, { headers }).pipe( map( data => data));
  }
}
